export const ActivityConfig = {
    name            : 'Activity stream',
    menuName        : 'Activity',
    icon            : 'i5-activity',
    image           : 'activity-stream',
    iconSvg         : 'isvg-view-activity-stream',
    url             : 'activity',
    stringId        : 'activity',
    description     : 'List of all project-related events and updates grouped by date, activity type, or other criteria.',
    inheritance     : true,
    canBeInProject  : true,
}

export const PROJECT_ACTIVITY_CONFIG = {
    ...ActivityConfig,
    // key2: "newValue2",  // Replacing the value for key2
}